import React from "react"
import BookAppointmentButton from "../reusable/ModalButtons/BookAppointmentButton"
import {useTranslation} from "next-i18next"
import AnimationComponent from "../reusable/components/AnimationComponent/AnimationComponent"

interface Props{
	visible: boolean
}

const BookConsultationFixedBtn = ({visible}: Props): React.ReactElement => {
	const {t} = useTranslation()

	const icon = <img src="/assets/icons/componentsIcons/consultation.png"
		height={24}
		alt=""/>

	return (
		<AnimationComponent inProp={visible}
			type="slideRight">
			<div style={{zIndex: 10000}}
				className="position-fixed bottom-0 end-0 start-0">
				<BookAppointmentButton high
					textColor="#212529"
					bgColor="#FEC04D"
					color="#212529"
					label={t("Beratung Buchen")}
					icon={icon}/>
			</div>
		</AnimationComponent>
	)
}

export default BookConsultationFixedBtn
